import { render, staticRenderFns } from "./HeaderWallet.vue?vue&type=template&id=8ad4e752&scoped=true&"
import script from "./HeaderWallet.vue?vue&type=script&lang=js&"
export * from "./HeaderWallet.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWallet.vue?vue&type=style&index=0&id=8ad4e752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad4e752",
  null
  
)

export default component.exports